import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";

export default function RegisterPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(email, password, name);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F5EF] p-4" data-testid="register-page">
      <div className="w-full max-w-md animate-fade-in-up">
        <div className="mb-8 text-center">
          <img src="/assets/stratum_logo.png" alt="Stratum" className="h-12 mx-auto mb-6" />
          <h1 className="font-display text-3xl font-semibold text-[#0B1020] mb-2">Create Account</h1>
          <p className="text-[#6B7280]">Start managing your asset register</p>
        </div>

        <div className="stratum-card p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            {error && (
              <div className="p-3 rounded-lg bg-[#991B1B]/10 text-[#991B1B] text-sm" data-testid="register-error">{error}</div>
            )}
            <div>
              <label className="block text-sm font-medium text-[#1A1A1A] mb-1.5">Full Name</label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="stratum-input w-full" placeholder="Your name" required data-testid="register-name-input" />
            </div>
            <div>
              <label className="block text-sm font-medium text-[#1A1A1A] mb-1.5">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="stratum-input w-full" placeholder="you@company.com" required data-testid="register-email-input" />
            </div>
            <div>
              <label className="block text-sm font-medium text-[#1A1A1A] mb-1.5">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="stratum-input w-full" placeholder="Min 6 characters" required minLength={6} data-testid="register-password-input" />
            </div>
            <button type="submit" disabled={loading} className="stratum-btn-primary w-full py-3 disabled:opacity-50" data-testid="register-submit-btn">
              {loading ? "Creating account..." : "Create Account"}
            </button>
          </form>
        </div>

        <p className="mt-6 text-center text-sm text-[#6B7280]">
          Already have an account?{" "}
          <Link to="/login" className="text-[#C8A961] hover:underline font-medium" data-testid="login-link">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
